/*eslint-disable */

import { bus } from '@/main';

export default {
  name: 'payment-failed',
  components: {},
  props: [],
  data () {
    return {
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    needHelpMethod(){
      const supportChatIconBtn = document.getElementById("helpChatRoomId");
      supportChatIconBtn.click();
    }
  }
}